import { render } from "./picking-queue.vue?vue&type=template&id=5793cbbd&scoped=true"
import script from "./picking-queue.vue?vue&type=script&lang=js"
export * from "./picking-queue.vue?vue&type=script&lang=js"

import "./picking-queue.vue?vue&type=style&index=0&id=5793cbbd&scoped=true&lang=css"

import exportComponent from "/home/oawms/app/ru_releases/20261004163500/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5793cbbd"]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBadge,QSlideTransition});
